import { Skeleton, Stack, Typography } from '@mui/material';
import { styled as muiStyled } from '@mui/material/styles';
import { abyssColors, COMPONENT_CARD_BACKGROUND } from '@/theme/colors';

export const Card = muiStyled(Stack)(({ highlighted = false }: { highlighted?: boolean }) => ({
  background: highlighted ? abyssColors.primary[400] : COMPONENT_CARD_BACKGROUND,
  padding: '1.2rem 1.2rem',
  gap: '1.2rem',
  height: '7.4rem',
  cursor: 'pointer',
}));

export const DetailRow = muiStyled(Stack)({
  gap: '0.8rem',
  flexDirection: 'row',
  alignItems: 'center',
  justifyContent: 'space-between',
});

export const DetailText = muiStyled(Typography)(
  ({ highlighted = false }: { highlighted?: boolean }) => ({
    fontWeight: 400,
    color: highlighted ? abyssColors.primary[100] : abyssColors.primary[400],
    lineHeight: '1.4rem',
    letterSpacing: 'normal',
  })
);

export const CustomSkeleton = muiStyled(Skeleton)({
  background: 'transparent',
  transform: 'unset',
});
